import { useState } from "react";
import { VirtuosoGrid } from "react-virtuoso";
import { Loader2 } from "lucide-react";
import { BusinessCard } from "./BusinessCard";
import { InspirationModal } from "./InspirationModal";
import { BuildModal } from "./BuildModal";

/**
 * Windowed (virtualized) business card grid that scales to 10,000+ items.
 * - Virtualizes rows so only visible cards live in the DOM.
 * - `onEndReached` enables infinite scroll (browse/category views).
 * - `loadingMore` renders a footer spinner while the next page loads.
 */
export const VirtualBusinessGrid = ({ businesses, onEndReached, loadingMore = false }) => {
  const [selected, setSelected] = useState(null);
  const [building, setBuilding] = useState(null);

  return (
    <>
      <VirtuosoGrid
        useWindowScroll
        data={businesses}
        overscan={800}
        endReached={onEndReached}
        listClassName="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        data-testid="virtual-business-grid"
        computeItemKey={(index, b) => b?.id || index}
        itemContent={(index, b) => (
          <BusinessCard business={b} index={index} onInspire={setSelected} />
        )}
        components={{
          Footer: () =>
            loadingMore ? (
              <div className="flex justify-center py-10" data-testid="grid-loading-more">
                <Loader2 className="animate-spin text-[#D4AF37]" size={26} />
              </div>
            ) : null,
        }}
      />
      <InspirationModal
        business={selected}
        onClose={() => setSelected(null)}
        onBuild={(b) => setBuilding(b)}
      />
      <BuildModal business={building} onClose={() => setBuilding(null)} />
    </>
  );
};
